import {ErFilter} from './ErFilter'
import {useEffect, useState} from 'react'
import {FilterRule} from '../core/_models'
import {updateQuery} from '../slices/erFilterSlice'
import {usersAPI} from '../../../services/UsersService'
import {DateRangePickerEr} from '../helpers/DateRangePickerEr'
import {OverlayTrigger, ToggleButton, ToggleButtonGroup, Tooltip} from 'react-bootstrap'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {Link, useLocation, useParams} from 'react-router-dom'
import {KTSVG} from '../../../template/helpers'

type IToggleButtonValue = 'ALL' | 'INBOUND' | 'OUTBOUND'
const genId = () => Math.random().toString(36).slice(2)

const ErHeader = () => {
  const {appId} = useParams()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const query = useAppSelector((state) => state.erFilter)
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const [toggleButtonValue, setToggleButtonValue] = useState<IToggleButtonValue>('ALL')
  const [linkCdr] = useState<string>(location.pathname.includes('/management') ? '/management/cdr' : '/cdr')

  useEffect(() => {
    const directionRule = query?.rules?.items?.find((rule) => rule.column === 'direction')
    if (directionRule?.value === '' || directionRule?.value === undefined) {
      setToggleButtonValue('ALL')
      return
    }

    if (directionRule?.value) {
      setToggleButtonValue(directionRule.value as IToggleButtonValue)
    }
  }, [query])

  const handleInbound = (val: IToggleButtonValue) => {
    const rulesPayload = {
      id: genId(),
      column: 'direction',
      type: 'string',
      operator: 'eq',
      value: val,
    } as FilterRule

    const updatedItems =
      query.rules?.items?.map((rule) => (rule.column === 'direction' ? {...rule, value: val} : rule)) ?? []

    if (!updatedItems.some((rule) => rule.column === 'direction')) {
      updatedItems.push(rulesPayload)
    }

    dispatch(
      updateQuery({
        ...query,
        rules: {
          operator: '$and',
          items: updatedItems,
        },
      })
    )
  }

  return (
    <div className='card-header border-1'>
      <div className='d-flex align-items-center mt-2 w-100'>
        <div className='d-flex align-items-center gap-2'>
          <div className='w-290px'>
            <DateRangePickerEr
              language={currentUser?.language}
              timeZone={currentUser?.time_zone}
              rangeId='1'
              onlyIcon={false}
            />
          </div>
          <ErFilter />
          <ToggleButtonGroup
            type='radio'
            name='options'
            defaultValue={'ALL'}
            onChange={(val) => {
              setToggleButtonValue(val)
            }}
          >
            <ToggleButton
              id='tbg-radio-1'
              value={'ALL'}
              variant={toggleButtonValue === 'ALL' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => handleInbound('ALL')}
            >
              Все
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-2'
              value={'INBOUND'}
              variant={toggleButtonValue === 'INBOUND' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => handleInbound('INBOUND')}
            >
              <i className='bi bi-arrow-down-right-circle fs-3' /> Входящие
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-3'
              value={'OUTBOUND'}
              variant={toggleButtonValue === 'OUTBOUND' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => handleInbound('OUTBOUND')}
            >
              <i className='bi bi-arrow-up-left-circle text-success fs-3' />
              Исходящие
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className='ms-auto'>
          <OverlayTrigger
            delay={{show: 50, hide: 50}}
            overlay={
              <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                Перейти к журналу звонков
              </Tooltip>
            }
          >
            <Link to={`${linkCdr}/${appId}`}>
              <span className='badge badge-light-success cursor-pointer'>
                <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-success' />
              </span>
            </Link>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}

export {ErHeader}
